import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { environment } from "../../../../environments/environment";
import { TenderTypesEnum } from "../../models/tender-search-body";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { CommonExplainModule } from "../../../common-explain/common-explain.module";
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from "@angular/cdk/overlay";
import { SearchableEntityComponent } from "../searchable-entity/searchable-entity.component";
import { NgTemplateOutlet } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { DisableScrollContainerDirective } from "../../directives/disabled-scroll-container.directive";
import {
  OverflowListComponent
} from "../../../common-explain/components/overflow-list-button/overflow-list-button.component";

export interface LightTender {
  id: string;
  assignees: string[];
  amount?: { min: number, max: number, total: number };
}

@Component({
  selector: 'app-assignees-popover',
  standalone: true,
  imports: [
    NgbTooltip,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    SearchableEntityComponent,
    NgTemplateOutlet,
    TranslateModule,
    CommonExplainModule,
    DisableScrollContainerDirective,
    OverflowListComponent
  ],
  templateUrl: './assignees-popover.component.html',
  styleUrl: './assignees-popover.component.scss'
})
export class AssigneesPopoverComponent implements OnChanges {
  protected readonly TenderTypesEnum = TenderTypesEnum;
  environment = environment;
  @Input({required: true}) tender!: LightTender;
  @Input() tenderId?: string;
  @Input() styleClass: 'regular' | 'dark' = 'regular';
  @Output() toggleOverlay = new EventEmitter<string>();
  @Output() closeOverlay = new EventEmitter<void>();
  items: { label: string }[] = [];

  positions: ConnectedPosition[] = [
    {originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top'},
    {originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom'},
    {originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top'},
    {originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom'},
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['assigneePopOverId']?.currentValue) {
      this.tenderId = changes['assigneePopOverId'].currentValue;
    }
    if (changes['tender']?.currentValue) {
      this.items = this.tender.assignees.map(assignee => ({label: assignee}));
    }
  }

  toggle(event: string) {
    this.toggleOverlay.emit(event);
  }

  close() {
    this.closeOverlay.emit();
  }

}
